import React from "react";
import {Button, ButtonGroup, Menu, MenuItem} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {styled} from "styled-components";

const StyledButtonGroup = styled(ButtonGroup)`
  && {
    box-shadow: none;
    overflow: hidden;
  }
`;

const StyledButton = styled(Button)`
  && {
    box-shadow: none;
    border-radius: 0;
    text-transform: none;
    font-weight: 500;

    &:not(:last-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
`;

const MultiLineButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;

  .line1 {
    font-size: 0.875rem;
    font-weight: 500;
  }

  .line2 {
    font-size: 0.75rem;
    opacity: 0.85;
    margin-top: 2px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  && {
    padding: 10px 16px;
  }
`;

const SplitSaveButton = ({
  canSave,
  canSaveAndArchive,
  isDraftMode,
  styles,
  handleSave,
  handleSaveAndArchive,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const handleSaveAndArchiveClick = () => {
    if (isDraftMode) {
      handleSave();
      return;
    }
    handleSaveAndArchive();
  };

  const handleMenuOpen = event => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleOptionClick = action => {
    handleMenuClose();
    switch (action) {
      case "save":
        handleSave();
        break;
      case "saveAndArchive":
        handleSaveAndArchive();
        break;
      default:
        break;
    }
  };
  return (
    <>
      <StyledButtonGroup
        variant="contained"
        color="primary"
        disabled={!canSave}
        style={{borderRadius: styles.button.borderRadius ?? "0px"}}
      >
        <StyledButton
          onClick={handleSaveAndArchiveClick}
          style={{...styles.button, borderRadius: "0px"}}
        >
          <MultiLineButton>
            {isDraftMode ? (
              "Save"
            ) : (
              <>
                <div className="line1">Save</div>
                <div className="line2">& Archive</div>
              </>
            )}
          </MultiLineButton>
        </StyledButton>
        {canSaveAndArchive && (
          <StyledButton
            size="small"
            aria-controls="split-button-menu"
            aria-haspopup="true"
            onClick={handleMenuOpen}
            style={{
              ...styles.button,
              minWidth: "auto",
              borderRadius: "0px",
              paddingLeft: "8px",
              paddingRight: "8px",
            }}
          >
            <ArrowDropDownIcon />
          </StyledButton>
        )}
      </StyledButtonGroup>

      <Menu
        id="split-button-menu"
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
      >
        <StyledMenuItem onClick={() => handleOptionClick("saveAndArchive")}>
          Save & Archive
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleOptionClick("save")}>
          Save & Keep
        </StyledMenuItem>
      </Menu>
    </>
  );
};

export default SplitSaveButton;
